module.exports = __webpack_public_path__ + "img/artist-gabrielberrios.68daf3e9.jpg";